import React, { useState } from 'react';
import {
  Table,
  TableHead,
  TableCell,
  TableBody,
  LinearProgress,
  TableRow,
  TablePagination,
  TableFooter,
} from '@material-ui/core';
import { Alert } from '@mui/material';
import TablePaginationActions from '@material-ui/core/TablePagination/TablePaginationActions';
import { useSelector } from 'react-redux';

import { TableBox } from 'retired/Box';
import { ChapterRequestStatusEnum, useChapterRequestsQuery } from 'generated/graphql';
import { selectOrganization, selectUser } from 'entities/user/selectors';

import ChapterRequestRow from './ChapterRequestRow';

const RejectedChapterRequests = () => {
  const user = useSelector(selectUser);
  const organization = useSelector(selectOrganization);

  const [page, setPage] = useState(0);
  const [limit, setRowsPerPage] = useState(10);

  const { data, loading, error } = useChapterRequestsQuery({
    variables: {
      statuses: [ChapterRequestStatusEnum.Rejected, ChapterRequestStatusEnum.Failed],
      parentNonprofitId: organization?.nonprofitId,
      offset: page * limit,
      limit,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
  });

  if (!user) {
    return null;
  }

  const chapterRequests = data?.chapterRequests?.results || [];
  const total = data?.chapterRequests?.total || 0;

  return (
    <>
      {loading ? <LinearProgress /> : <div style={{ height: 4 }} />}

      {chapterRequests.length > 0 && (
        <TableBox>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nonprofit Name</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Submitted At</TableCell>
                <TableCell>Rejected At</TableCell>
                <TableCell>Reason</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chapterRequests.map((chapterRequest) => (
                <ChapterRequestRow key={chapterRequest.id} chapterRequest={chapterRequest} />
              ))}
            </TableBody>

            <TableFooter style={{ width: '100%' }}>
              <TableRow>
                <TableCell>{`Total: ${total}`}</TableCell>

                <TablePagination
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  colSpan={5}
                  count={total}
                  rowsPerPage={limit}
                  page={page}
                  onPageChange={(_event, newPage): void => setPage(newPage)}
                  onRowsPerPageChange={(event): void => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                  }}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableBox>
      )}

      {error && <Alert security="error">There was an error loading the data</Alert>}
    </>
  );
};

export default RejectedChapterRequests;
